import { useState, useEffect } from "react";
import AxiosInstance from "../Axios";
import 'react-toastify/dist/ReactToastify.css';
import { CButton, CFormSelect, CFormInput, CFormTextarea } from "@coreui/react";
import { cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { BsSortNumericDown } from 'react-icons/bs';
import { sortObj } from "../store/sortObj";
import React from "react";
import BasicModal from "../Modal";
import ModelsObjectEditNew from "./ModelsObjectEditNew";

const ModelsObject = ({ dataId, currentModels, popup }) => {

  const [modelsObject, setModelsObject] = useState([]);
  const [selectedData, setSelectedData] = useState(null); // Вибрана модель для редагування
  const [showModalItemUpdate, setShowModalItemUpdate] = useState(false); // Показати модальне вікно для оновлення моделі

  // Функція для відкривання модального вікна та оновлення даних
  const actionShowModalItemUpdate = (rez) => {
    setShowModalItemUpdate(rez);
    if (!rez) {
      setSelectedData(rez);
    };
  };

  useEffect(() => {
    if (currentModels !== "" && currentModels !== null) {
      setModelsObject(currentModels);
    }
  }, [])

  function getModelObjects() {
    AxiosInstance.get(`/models?object=${dataId}`).then((response) => {
      const data = response.data['hydra:member'];
      setModelsObject(data);
    });
  }

  function removeModel(model) {
    AxiosInstance.delete(`/models/${model.id}`)
    .then(() => {
      getModelObjects();
      popup.toastifySuccess('Модель видалено');
    })
    .catch(() => {
      popup.toastifyWarning('Помилка видалення моделі');
    });
  }

  function showElement(model) {
    setSelectedData(model);
    setShowModalItemUpdate(true);
  }

  return (
    <div className="models-object">
      <div className="models-object__list">
        {modelsObject.length > 0 && sortObj(modelsObject, 'sort').map((model, index) => {
            return <div key={index} className="mb-3 w-100 d-flex align-items-center justify-content-between">
                    <div onClick={()=> showElement(model)} className="models-title d-flex align-items-center gap-3">
                        <small><BsSortNumericDown />{model.sort}</small>
                        <span className="models-template-img">
                          <img src='/models-template.svg' alt='model-template' />
                        </span>
                        <span className="models-title-type">{model.type}</span>
                    </div>
                    <div className="models-action d-flex align-items-center gap-1">
                    <CButton color="none" variant="outline" className='models-edit-btn'
                      onClick={()=> showElement(model)} 
                      style={{ cursor: "pointer" }} 
                      title="Редагувати"
                    >
                      <img src='/custom-edit.svg' alt='edit-template' /> Редагувати
                    </CButton>
                    <CButton className="ms-2" color="danger" variant="outline" onClick={() => removeModel(model)}>
                        <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
                    </CButton>
                    </div>
                </div>
        })}
      {/* Модальне вікно з вибраною моделью */}
        <div className="mt-4 models-outer">
          <BasicModal
            show={showModalItemUpdate}
            actionShowModal={actionShowModalItemUpdate}
            title={selectedData ? "Редагувати модель" : "Додати модель"}
            className={"models-popup"}
            btn_name={<>+ Додати модель</>}
            content={
              <ModelsObjectEditNew
                toastifySuccess={popup.toastifySuccess}
                parentId={dataId}
                data={selectedData}
                getModelObjects={getModelObjects}
                actionShowModal={actionShowModalItemUpdate}
              />
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ModelsObject;